import { PressEvent } from "react-aria-components";
import { Button } from "../../Common/Buttons/Button";

interface SharePropertyInfoButtonProps {
  onPress: (_: PressEvent) => void;
  disabled: boolean;
}
export const SharePropertyInfoButton = ({
  onPress,
  disabled,
}: SharePropertyInfoButtonProps) => (
  <Button
    onPress={onPress}
    size="small"
    variant="outlineInverted"
    isDisabled={disabled}
    iconStart="mail"
    title="Share public profile"
  />
);
